declare namespace $ {

	type $mol_button_major__sub_shm_hitalama_map_widget_float_iframe_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_iframe_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_iframe['run_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $shm_hitalama_map_widget_float_iframe_frame__uri_shm_hitalama_map_widget_float_iframe_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_iframe['uri'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_iframe_frame['uri'] >
	>
	type $shm_hitalama_map_widget_float_iframe_frame__html_shm_hitalama_map_widget_float_iframe_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_iframe['html'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_iframe_frame['html'] >
	>
	type $shm_hitalama_map_widget_float_iframe_frame__event_load_shm_hitalama_map_widget_float_iframe_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_iframe['iframe_on_load'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_iframe_frame['event_load'] >
	>
	type $shm_hitalama_map_widget_float_iframe_frame__widget_link_str_shm_hitalama_map_widget_float_iframe_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_iframe['widget_link_str'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_iframe_frame['widget_link_str'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_iframe_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_iframe extends $shm_hitalama_map_widget_float {
		pool_active( ): any
		Run_icon( ): $mol_icon_play
		run_click( next?: any ): any
		Run( ): $mol_button_major
		uri( ): string
		html( ): any
		iframe_on_load( next?: any ): any
		widget_link_str( ): string
		Iframe( ): $shm_hitalama_map_widget_float_iframe_frame
		tg_post_script( ): readonly(any)[]
		Tg_post_dom( ): $mol_view
		iframe_content( ): readonly(any)[]
		Blocker( ): $mol_view
		blocker( ): readonly(any)[]
		auto( ): readonly(any)[]
		controls( ): readonly(any)[]
		iframe_title( next?: string ): string
	}
	
	export class $shm_hitalama_map_widget_float_iframe_frame extends $mol_frame {
		event_load( next?: any ): any
		widget_link_str( ): string
		event( ): ({ 
			load( next?: ReturnType< $shm_hitalama_map_widget_float_iframe_frame['event_load'] > ): ReturnType< $shm_hitalama_map_widget_float_iframe_frame['event_load'] >,
		})  & ReturnType< $mol_frame['event'] >
		attr( ): ({ 
			'data-crusref': ReturnType< $shm_hitalama_map_widget_float_iframe_frame['widget_link_str'] >,
		})  & ReturnType< $mol_frame['attr'] >
	}
	
}

//# sourceMappingURL=iframe.view.tree.d.ts.map